import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  show: false,
  ticketType: 0,
  isAccepted: false,
};

const warningAlertSlice = createSlice({
  name: "warning-notification",
  initialState: initialState,
  reducers: {
    showAlert: (state, { payload }) => {
      state.show = true;
      state.ticketType = payload;
    },
    hideAlert: (state) => {
      state.show = false;
      state.isAccepted = initialState.isAccepted;
    },
    acceptConsent: (state, { payload }) => {
      state.show = false;
      state.isAccepted = payload;
    },
  },
});

export const { showAlert, hideAlert, acceptConsent } =
  warningAlertSlice.actions;

export default warningAlertSlice.reducer;
